import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '~/utils/redux/hooks';
import { selectUser } from '~/thunks/auth/authSlice';
import { AppRole, getAppRole } from '~/utils/helper/role';
import { getHomePath } from '~/utils/routes/home';

type Props = {
  allow: AppRole[];
};

const RoleRoute = ({ allow }: Props) => {
  const role = getAppRole(useAppSelector(selectUser));

  if (!role || !allow.includes(role)) {
    return <Navigate to={getHomePath(role)} replace />;
  }

  return <Outlet />;
};

export default RoleRoute;
